import useCurrentUser from "../../../../hooks/useCurrentUser";
import { normalizeText, useBaseNotificationSubscription } from "../../../../shared/BaseNotificationList";
import { gymDocRef, notificationsCollectionRef } from "../../../../utils/referencies";
import { IGymNotificationEvent, IGymNotificationType } from "./types";

export const gymSubscriptionQuery = (userId: string) => {
  if (!userId) return;

  return notificationsCollectionRef
    .where("receivers", "array-contains", userId)
    .where("event", "in", [
      IGymNotificationEvent.canceled,
      IGymNotificationEvent.created,
      IGymNotificationEvent.expired,
      IGymNotificationEvent.ANNOUNCMENT_CREATED,
    ])
    .limit(5)
    .orderBy("createdAt", "desc");
};

export const gymNotificationData: any = {
  [IGymNotificationType.gym_subscription]: {
    [IGymNotificationEvent.created]: {
      title: normalizeText(`New Gym Subscription`),
      color: "#30bd58",
      char: "S",
    },
    [IGymNotificationEvent.canceled]: {
      title: normalizeText(`Cancelled Gym Subscription`),
      color: "#fced48",
      char: "C",
    },
    [IGymNotificationEvent.expired]: {
      title: normalizeText(`Expired Gym Subscription`),
      color: "#ff4141",
      char: "E",
    },
  },
  [IGymNotificationType.ANNOUNCMENTS]: {
    [IGymNotificationEvent.ANNOUNCMENT_CREATED]: {
      title: normalizeText(`New Announcment`),
      color: "#ccc",
      char: "A",
    },
  },
};

export const generateProperPath = (Id: string, type: IGymNotificationType) => {
  console.log({ Id, type });
  return `/subscribedGyms`;
};

export const redirectOnClick = (notification: any, redirect: any) => {
  redirect(generateProperPath(notification.meta.document.id, notification.type));
};

export const onSystemNotificationClickHandler = (notification: Record<string, any>) => {
  window.open(generateProperPath(notification.meta.document.id, notification.type));
};

const useGymNotificationList = (canReceiveNotification: boolean) => {
  const { user } = useCurrentUser();

  useBaseNotificationSubscription({
    canReceiveNotification,
    query: gymSubscriptionQuery(user.id!)!,
    unseenQuery: gymDocRef(user.id!),
    canPlaySound: (data) => {
      return !data.seenBy.length;
    },
    userData: gymNotificationData,
    onClick: onSystemNotificationClickHandler,
  });
};

export default useGymNotificationList;
